module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Da-Eb.c0ab7d07.png";